import React from 'react';
import './plaza.scss';

const PartySelector = ({ parties, current = false, onChange }) => (
  <nav className='partySelector'>
    <div className='container'>
      <ul className='parties'>
        {parties &&
          parties.map((party, i) => (
            <li
              key={party.name}
              className={current === i ? 'party current' : 'party'}
              onClick={() => onChange(i)}
            >
              <div className='imgContainer'>
                <img
                  src={party.person.photo}
                  alt={party.name}
                  title={party.shortname}
                  style={{ backgroundColor: party.color }}
                />
              </div>
              <div className='txt' style={{ backgroundColor: party.color }}>
                {party.shortname}
              </div>
            </li>
          ))}
      </ul>
      {current !== false && (
        <span className='btn' onClick={() => onChange(false)}>
          VER TODOS
        </span>
      )}
    </div>
  </nav>
);

export default PartySelector;
